
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import LocationOn from "@material-ui/icons/LocationOn";
import Notifications from "@material-ui/icons/Notifications";

import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import UserProfile from "views/UserProfile/UserProfile.js";
import Historicos from "views/Historicos/Historicos.js";
import Predicciones from "views/Predicciones/Predicciones.js";
import Typography from "views/Typography/Typography.js";
import Icons from "views/Icons/Icons.js";
import Maps from "views/Maps/Maps.js";
import NotificationsPage from "views/Notifications/Notifications.js";
//import Unarchive from "@material-ui/icons/Unarchive";
//import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";

// core components/views for RTL layout
import RTLPage from "views/RTLPage/RTLPage.js";
import { useSelector } from 'react-redux';

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Tablero",
    name_en: "Dashboard",
    rtlName: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/hist",
    name: "Historicos",
    name_en: "Historic",
    rtlName: "Historic",
    icon: "content_paste",
    component: Historicos,
    layout: "/admin",
  },
  {
    path: "/predicciones",
    name: "Pronósticos",
    name_en: "Forecast",
    rtlName: "Forecast",
    icon: BubbleChart,
    component: Predicciones,
    layout: "/admin",
  },
  {
    path: "/notifications",
    name: "Notificaciones",
    name_en: "Notifications",
    rtlName: "Notifications",
    icon: Notifications,
    component: NotificationsPage,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "Perfil",
    name_en: "Profile",
    rtlName: "Profile",
    icon: Person,
    component: UserProfile,
    layout: "/admin",
  },
  
/*
  {
    path: "/typography",
    name: "Typography",
    rtlName: "طباعة",
    icon: LibraryBooks,
    component: Typography,
    layout: "/admin",
  },
  {
    path: "/maps",
    name: "Maps",
    rtlName: "خرائط",
    icon: LocationOn,
    component: Maps,
    layout: "/admin",
  },
  
  {
    path: "/rtl-page",
    name: "RTL Support",
    rtlName: "پشتیبانی از راست به چپ",
    icon: Language,
    component: RTLPage,
    layout: "/rtl",
  },
   {
    path: "/upgrade-to-pro",
    name: "Upgrade To PRO",
    rtlName: "التطور للاحترافية",
    icon: Unarchive,
    component: UpgradeToPro,
    layout: "/admin",
  }, */
];

export default dashboardRoutes;
